import { BaseService } from '../base';

export type TheftProtectionRatingType = {
  code: number;
  description: string;
};

export type TheftProtectionRatingTypesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type TheftProtectionRatingTypesResponse = {
  data: TheftProtectionRatingType[];
  meta: TheftProtectionRatingTypesMeta;
};

export class TheftProtectionRatingTypesService extends BaseService {
  async getTheftProtectionRatingTypes(): Promise<{
    success: boolean;
    data?: TheftProtectionRatingTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/theft-protection-rating-types`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<TheftProtectionRatingTypesResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar sistemas de proteção contra roubo',
      };
    }
  }
}

export const theftProtectionRatingTypesService =
  new TheftProtectionRatingTypesService();
